import { React, useEffect, useState, useContext } from 'react'
import axios from "axios";
import WholesalePriceGraph from "../../../../Components/WholesalePriceGraph";
// import LineChart from "../../Components/LineChart";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../../App";
import { API_URL } from '../../../../Constant';

function WholesalePriceGraphReports() {

  const [years, setYears] = useState([]);
  const [yearName, setyearName] = useState('');
  const [months, setMonth] = useState([]);
  const [monthName, setMonthName] = useState('');
  const [districtList, setDistrictList] = useState([]);
  const [groupName, setGroupName] = useState('');
  const [groupId, setGroupId] = useState('');
  const [chart, setChart] = useState('bar_chart');
  const [wholesalePrice, setwholesalePriceData] = useState('');
  const [districtId, setDistrictName] = useState('');
  const [districtName, setDistrictNames] = useState('');


  const handleDistrictChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedDistrictId = selectedOption.value;
    const selectedDistrictName = selectedOption.text;


    setDistrictName(selectedDistrictId);
    setDistrictNames(selectedDistrictName);


  };

  const shortMonthToFull = (shortMonth) => {
    const monthMapping = {
      JAN: 'January',
      FEB: 'February',
      MAR: 'March',
      APR: 'April',
      MAY: 'May',
      JUN: 'June',
      JUL: 'July',
      AUG: 'August',
      SEP: 'September',
      OCT: 'October',
      NOV: 'November',
      DEC: 'December',
    };
    return monthMapping[shortMonth] || null;
  }


  const config = {
    headers: {
      Authorization: `Bearer ${useContext(MyContextProvider).token}`,
    },
  };


  useEffect(() => { //Get all Years Data
    //Years
    showLoading(true)
    axios
      .get(`${API_URL}api/graph/getYears`, config)
      .then((res) => {
        let yearDataResponse = res.data;
        if (yearDataResponse.status) {
          setYears(yearDataResponse.data);
          showLoading(false)
        }
      }).catch((err) => console.log(err));

    // All district list
    const fetchDistrictList = async () => {
      try {
        const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
        const allDistrict = response.data;

        if (allDistrict.status) {
          setDistrictList(allDistrict.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };
    fetchDistrictList();
  }, []);

  const yearOnChange = (e) => { //Get all Months data
    setyearName(e.target.value);
    if (e.target.value === '') {
      return false;
    }
    showLoading(true)
    axios
      .get(`${API_URL}api/graph/getMonths/${e.target.value}`, config) //${process.env.REACT_APP_API_URL}
      .then((res) => {
        let monthDataResponse = res.data;
        if (monthDataResponse.status) {
          setMonth(monthDataResponse.data);
          showLoading(false)
        }
      })
      .catch((err) => console.log(err));
  }


  const handleSubmit = async (e) => {

    if (districtId === '') {
      toast.error(messages.DISTRICT_NAME_MSG, messages.COLOR_RED);
      return;
    }


    if (yearName === '') {
      toast.error(messages.YEAR_NAME_MSG, messages.COLOR_RED);
      return;
    }

    if (monthName === '') {
      toast.error(messages.MONTH_NAME_MSG, messages.COLOR_RED);
      return;
    }
    const post_data = {
      chart: chart,
      district_code: districtId,
      year_name: yearName,
      month_name: monthName
    }

    try {

      showLoading(true);

      const response = await axios.post(`${API_URL}api/graph/Usp_WholeSalePriceGraph`, post_data, config);
      const pendencyData = response.data;

      if (pendencyData.status) {
        setwholesalePriceData(pendencyData.data);
        showLoading(false);
      }
    } catch (error) {
      console.error(error);
      showLoading(false);
    }

  }

  return (
    <>
      {/* Page Content Open */}
      <div className="container-fluid py-3">
        <ToastContainer />
        <GlobalLoading />
        {/* Search Filter Open */}

        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                <label className="fw-bold h6">District</label>
                <select
                  value={districtId}
                  onChange={handleDistrictChange}
                  name="district_name"
                  className="form-select"
                >
                  <option value="">Select District</option>
                  {districtList &&
                    districtList
                      .slice()
                      .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                      .map((ele, index) => (
                        <option key={index} value={ele.DISTRICT_CODE}>
                          {ele.DISTRICT_NAME}
                        </option>
                      ))}
                </select>
              </div>



              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                <label className="fw-bold h6">Year</label>
                <select value={yearName} onChange={yearOnChange} name="year_name" className="form-select" >
                  <option value="">Select Year</option>
                  {years && years.map((ele, index) => (
                    <option key={index} value={ele.CURRENT_YEAR}>{ele.CURRENT_YEAR}</option>
                  ))
                  }

                </select>
              </div>


              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                <label className="fw-bold h6">Month</label>
                <select value={monthName} onChange={(e) => (setMonthName(e.target.value))} name="month_name" className="form-select">
                  <option value="">Select Month</option>
                  {months && months.map((ele, i) => (
                    <option key={i} value={ele.MONTH}>{shortMonthToFull(ele.MONTH)}</option>
                  ))

                  }
                </select>
              </div>


              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label className="w-100 mb-2 fw-bold h6">Chart Type</label>
                <div className="form-check form-check-inline me-2">
                  <input type="radio" onChange={(e) => (setChart(e.target.value))} checked={chart === 'bar_chart'} className="form-check-input" id="radio1" name="bar_chart" value="bar_chart" />
                  <label className="form-check-label" htmlFor="radio1">Bar Chart</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" disabled onChange={(e) => (setChart(e.target.value))} checked={chart === 'line_chart'} className="form-check-input" id="radio2" name="line_chart" value="line_chart" />
                  <label className="form-check-label" htmlFor="radio2" >Line Chart</label>
                </div>
              </div>
              <div className="col-xl-3 col-lg-12 mb-3">

                <button type="submit" onClick={handleSubmit} className="btn btn_orange">Show</button>
                <button type="button" id="print" className="btn btn_gray ms-1">Print</button>
              </div>
            </div>
          </div>
        </div>
        {/* /Row */}
        {/* Search Filter Close */}
        {/*top 5 Items BarChart */}

        {/**********  Bar Chart **********/}
        {chart === 'bar_chart' &&
          wholesalePrice &&
          <WholesalePriceGraph graphData={wholesalePrice} shortMonthToFull={shortMonthToFull} districtNameSet={districtName} chartDetails={{ "chart_type": "Wholesale_Price_Chart" }} />
        }

      </div>

    </>
  )
}

export default WholesalePriceGraphReports